import * as Sentry from "@sentry/react";
import React from "react";
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from "react-router-dom";

export const initSentry = () => {
  try {
    const dsn = process.env.REACT_APP_SENTRY_DSN;
    if (!dsn) return;

    const integrations: any[] = [
      Sentry.reactRouterBrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ];

    // Safely add Replay only if supported in current environment
    if (typeof window !== "undefined" && typeof MutationObserver !== "undefined") {
      try {
        integrations.push(
          Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
          })
        );
      } catch (err) {
        console.warn("Sentry replay integration failed to load:", err);
      }
    }

    Sentry.init({
      dsn,
      environment: process.env.NODE_ENV || "development",
      integrations,
      // Tracing
      tracesSampleRate: process.env.NODE_ENV === "production" ? 0.2 : 1.0,
      tracePropagationTargets: [
        "localhost",
        process.env.REACT_APP_API_URL || "http://localhost:8000",
      ],
      // Session Replay
      replaysSessionSampleRate: process.env.NODE_ENV === "production" ? 0.1 : 0.5,
      replaysOnErrorSampleRate: 1.0,
    });
  } catch (error) {
    console.error("Failed to initialize Sentry:", error);
  }
};

initSentry();

export default Sentry;
